import ClinicNameRender from '@medical/components/ClinicNameRender'

export const combineNames = ({ clinicalDepartments, departmentNames }) =>
  clinicalDepartments.map(clinic => ({
    ...clinic,
    clinicName: `${ClinicNameRender({
      clinicalDepartment: clinic,
    })}_${departmentNames[clinic.name]}`,
  }))
